// Complete Material Specifications from Alwatania
// All measurements in millimeters (mm)

export const MATERIAL_SPECIFICATIONS = {
  'FMIF200001': {
    name: 'FFS BAG PP 120MIC IBNZAHR 2 SIDE PRINT',
    film_width: 545,
    min: 545,
    max: 552
  },
  'FMIF200002': {
    name: 'FFS BAG SABIC LD 85 X120MIC KEMYA',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200003': {
    name: 'FFS BAG SABIC LLD70 X120MIC KEMYA',
    film_width: 530,
    min: 530,
    max: 537
  },
  'FMIF200004': {
    name: 'FFS BAG SABIC LLD 77.5X120MIC KEMYA',
    film_width: 545,
    min: 545,
    max: 552
  },
  'FMIF200005': {
    name: 'FFS BAG SABIC LLD 85X120MIC KEMYA',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200006': {
    name: 'FFS BAG SABIC LLD85X120MIC KEMYA(GRANUL)',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200007': {
    name: 'FFS BAG SABIC LD 70MMX120MIC KEMYA',
    film_width: 530,
    min: 530,
    max: 537
  },
  'FMIF200008': {
    name: 'FFS BAG EXXON LLD 77.5MMX120MIC KEMYA',
    film_width: 545,
    min: 545,
    max: 552
  },
  'FMIF200009': {
    name: 'FFS BAG EXXON LLD 70MMX120MIC KEMYA',
    film_width: 530,
    min: 530,
    max: 537
  },
  'FMIF200010': {
    name: 'FFS BAG EXXON LLD85MMX120MIC KEMYA(GRAN)',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200011': {
    name: 'FFS BAG EXXON LLD 85MMX120MIC KEMYA',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200012': {
    name: 'FFS BAG EXXON LD 70MMX120MIC KEMYA',
    film_width: 530,
    min: 530,
    max: 537
  },
  'FMIF200013': {
    name: 'FFS BAG EXXON LD 85MMX120MIC KEMYA',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200014': {
    name: 'FFS BAG EXXON EXA 395+80MM X150 MIC KEMYA',
    film_width: 555,
    min: 555,
    max: 562
  },
  'FMIF200021': {
    name: 'FFS KEMYA PLAIN 70MMX120MIC',
    film_width: 530,
    min: 530,
    max: 537
  },
  'FMIF200022': {
    name: 'FFS KEMYA PLAIN 77.5MMX120MIC',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200023': {
    name: 'FFS KEMYA PLAIN 85MMX120MIC',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200033': {
    name: 'FFS BAG LLD77.5X120MIC KEMYA(GRANUL)',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200034': {
    name: 'FFS EXXON LLD77.5MMX120MIC KEMYA(GRANUL)',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200035': {
    name: 'FFS TASNEE PP390+80MM,120MIC-L.GLUE4494',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200037': {
    name: 'FFS BASEL PP390+80MM,120MIC-L.GLUE4365',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200038': {
    name: 'FFS NEUTRAL 390+80MM,120MIC-L.GLUE 4533',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200039': {
    name: 'FFS NEUTRAL 390+70MM,140MIG-L.GLUE 4534',
    film_width: 530,
    min: 530,
    max: 537
  },
  'FMIF200040': {
    name: 'FFS BASEL PE390+80MM,120MIC-L.GLUE4365',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200051': {
    name: 'FFS BASEL PE400+70MM,140MIC-L.GLUE 4493',
    film_width: 540,
    min: 540,
    max: 547
  },
  'FMIF200058': {
    name: 'FFS BAG F SABIC LD 85 X120MIC KEMYA',
    film_width: 560,
    min: 560,
    max: 569
  },
  'FMIF200059': {
    name: 'FFS BAG F SABIC LLD70 X120MIC KEMYA',
    film_width: 530,
    min: 530,
    max: 537
  },
  'FMIF200060': {
    name: 'FFS BAG F SABIC LLD 77.5X120MIC KEMYA',
    film_width: 545,
    min: 545,
    max: 552
  },
  'FMIF200061': {
    name: 'FFS BAG F SABIC LLD 85X120MIC KEMYA',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200062': {
    name: 'FFS F SABIC LLD85X120MIC KEMYA(GRANUL)',
    film_width: 540,
    min: 540,
    max: 547
  },
  'FMIF200063': {
    name: 'FFS BAG F SABIC LD 70MMX120MIC KEMYA',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200064': {
    name: 'FFS F SABIC LLD77.5X120MIC KEMYA(GRAN)',
    film_width: 545,
    min: 545,
    max: 552
  },
  'FMIF200075': {
    name: 'FFS BAG F EXXON LD 70MMX120MIC KEMYA SG',
    film_width: 530,
    min: 530,
    max: 537
  },
  'FMIF200076': {
    name: 'FFS BAG F EXXON LD 85MMX120MIC KEMYA SG',
    film_width: 560,
    min: 560,
    max: 567
  },
  'FMIF200079': {
    name: 'HDPE F 400+70MM,140MIC TASNE-4508 BIS',
    film_width: 540,
    min: 540,
    max: 547
  },
  'FMIF200080': {
    name: 'LDPE F 400+70MM,140MIC TASNE-4493 BIS',
    film_width: 540,
    min: 540,
    max: 547
  },
  'FMIF200081': {
    name: 'FFS F BASEL PE400+70MM 140ML-GLUE-4494',
    film_width: 540,
    min: 540,
    max: 547
  },
  'FMIF200082': {
    name: 'FFS F TASNE PP390+80MM,120ML-L.GLUE-4366',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200083': {
    name: 'FFS F BASEL PP390+80MM,120ML-GLUE-4493',
    film_width: 550,
    min: 550,
    max: 557
  },
  'FMIF200084': {
    name: 'FFS F BASEL PE400+70MM,140MIC TASNE-4496',
    film_width: 540,
    min: 540,
    max: 547
  },
  'FMIF200096': {
    name: 'HDPE F 400+70MM,140MIC TASNE-4508',
    film_width: 540,
    min: 540,
    max: 547
  },
  'FMIF200097': {
    name: 'LDPE F 400+70MM,140MIC',
    film_width: 540,
    min: 540,
    max: 547
  }
};

// Helper function to get material specs
export const getMaterialSpecs = (materialCode) => {
  const specs = MATERIAL_SPECIFICATIONS[materialCode];
  
  if (!specs) {
    console.warn(`Material code ${materialCode} not found in specifications`);
    // Return default values if material not found
    return {
      name: `Unknown Material (${materialCode})`,
      film_width: 550,
      min: 500,
      max: 600
    };
  }
  
  // Convert mm to meters for API data (if needed)
  return {
    ...specs,
    min_m: specs.min / 1000,  // Convert to meters
    max_m: specs.max / 1000,  // Convert to meters
    target_m: specs.film_width / 1000  // Convert to meters
  };
};

// Function to check if a width measurement is within spec
export const isWithinSpec = (widthInMeters, materialCode) => {
  const specs = getMaterialSpecs(materialCode);
  const widthInMM = widthInMeters * 1000; // Convert to mm
  return widthInMM >= specs.min && widthInMM <= specs.max;
};

// Function to get defect type
export const getDefectType = (widthInMeters, materialCode) => {
  const specs = getMaterialSpecs(materialCode);
  const widthInMM = widthInMeters * 1000;
  
  if (widthInMM < specs.min) {
    return {
      type: 'Under Spec',
      deviation: specs.min - widthInMM,
      percentage: ((specs.min - widthInMM) / specs.film_width * 100).toFixed(2)
    };
  } else if (widthInMM > specs.max) {
    return {
      type: 'Over Spec',
      deviation: widthInMM - specs.max,
      percentage: ((widthInMM - specs.max) / specs.film_width * 100).toFixed(2)
    };
  }
  
  return null; // No defect
};

// Function to format time for 24-hour display with 15-minute intervals
export const formatTimeAxis = (date) => {
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = Math.floor(date.getMinutes() / 15) * 15; // Round to nearest 15 minutes
  return `${hours}:${minutes.toString().padStart(2, '0')}`;
};

// Generate time labels for 24-hour period
export const generate24HourLabels = () => {
  const labels = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      labels.push(`${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`);
    }
  }
  return labels;
};

export default MATERIAL_SPECIFICATIONS;